'use strict';

var d3 = require('d3');

/**
 * No data bars
 *
 * Renders bars with no data
 *
 * @param svgPatternService
 * @returns {Function}
 * @constructor
 */
var NoDataBars = function NoDataBars(svgPatternService) {
  return function () {
    var params, scales;

    /**
     *
     * @param container
     */
    var noDataBars = function noDataBars(container) {
      var barWidth = params.direction === 'vertical' ? scales.yScale.rangeBand() : scales.xScale.rangeBand();
      var isViewport = container.filter('.viewport-groups').size() === 1;
      var noDataBars = container.selectAll('.stack.noData.visible');
      var patternId = isViewport ? 'noData-pattern-viewport' : 'noData-pattern';
      var patternUrl = svgPatternService.getPatternUrl(patternId);
      noDataBars.each(function (d) {
        // remove all gap children
        d3.select(this).selectAll('*').remove();
        var noDataBars = d3.select(this).selectAll('.noData').data([d]);
        noDataBars.enter().append('rect').attr('class', function (d) {
          return d.cssClass ? 'noData ' + d.cssClass : 'noData';
        });
        noDataBars.attr({
          'width': barWidth,
          'height': params.height
        }).style('fill', function (d) {
          if (d.patternId === 'noData-solid') {
            return false;
          }
          if (!isViewport && svgPatternService.isPatternAvailable(d.patternId)) {
            return svgPatternService.getPatternUrl(d.patternId);
          }
          return patternUrl;
        });
        if (params.isSparse) {
          noDataBars.attr({
            'x': params.xBarPadding,
            'width': function width(d) {
              return Math.abs(params.xScaleFactor * (d.noDataLength * params.xGapSize) - params.xBarPadding * 2);
            }
          });
        }
      });
    };

    /**
     * Sets/gets circle's params
     * @param value
     * @returns {group}
     */
    noDataBars.params = function (value) {
      params = value;
      return noDataBars;
    };

    /**
     * Sets/gets circle's scales
     * @param value
     * @returns {group}
     */
    noDataBars.scales = function (value) {
      scales = value;
      return noDataBars;
    };
    return noDataBars;
  };
};
NoDataBars.$inject = ['SvgPatternService'];
module.exports = NoDataBars;